import { render, staticRenderFns } from "./ManageFigureModal.vue?vue&type=template&id=060c1f6a&"
import script from "./ManageFigureModal.vue?vue&type=script&lang=js&"
export * from "./ManageFigureModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports